import React from 'react'
import {withRouter} from 'react-router'
import BrandNav from 'components/BrandNav'
import './styles.css'

class Store extends React.Component {
  render = () => {
    const brandId = this.props.match.params.brand

    return (
      <section style={{marginTop: '65px'}}>
        <BrandNav brand={brandId}/>
				<div className="container">
					<div className="row">
            <div className="col-sm-12">
              <div className="store feature boxed">
                <h3><i className="icon-Map-Marker2"></i>台北</h3>
                <div className="location">
                  <div className="col-sm-4">忠孝SOGO</div>
                  <div className="col-sm-4">台北市忠孝東路四段45號8樓</div>
                  <div className="col-sm-4">02-7711-6698</div>
                </div>
                <div className="location">
                  <div className="col-sm-4">復興SOGO</div>
                  <div className="col-sm-4">台北市忠孝東路三段300號8樓</div>
                  <div className="col-sm-4">02-8772-1862</div>
                </div>
                <div className="location">
                  <div className="col-sm-4">天母SOGO</div>
                  <div className="col-sm-4">台北市中山北路六段77號6樓</div>
                  <div className="col-sm-4">02-2835-3019</div>
                </div>
                <div className="location">
                  <div className="col-sm-4">信義新光A8</div>
                  <div className="col-sm-4">台北市松高路12號7樓</div>
                  <div className="col-sm-4">02-2722-2735</div>
                </div>
                <div className="location">
                  <div className="col-sm-4">寶慶遠百</div>
                  <div className="col-sm-4">台北市寶慶路32號7樓</div>
                  <div className="col-sm-4">02-2311-8108</div>
                </div>
              </div>
              <div className="store feature boxed">
                <h3><i className="icon-Map-Marker2"></i>新北</h3>
                <div className="location">
                  <div className="col-sm-4">板橋大遠百</div>
                  <div className="col-sm-4">新北市板橋區新站路28號7F</div>
                  <div className="col-sm-4">02-2952-5288</div>
                </div>
              </div> 
              <div className="store feature boxed">
                <h3><i className="icon-Map-Marker2"></i>桃園</h3>
                <div className="location">
                  <div className="col-sm-4">桃園南崁特力家居</div>
                  <div className="col-sm-4">桃園縣蘆竹鄉中正路1號B1</div>
                  <div className="col-sm-4">03-353-0164</div>
                </div>
                <div className="location">
                  <div className="col-sm-4">中壢SOGO</div>
                  <div className="col-sm-4">桃園市中壢區元化路357號7樓</div>
                  <div className="col-sm-4">03-280-6338</div>
                </div>
              </div>  
              <div className="store feature boxed">
                <h3><i className="icon-Map-Marker2"></i>新竹</h3>
                <div className="location">
                  <div className="col-sm-4">新竹大遠百</div>
                  <div className="col-sm-4">新竹市西大路323號5樓</div>
                  <div className="col-sm-4">03-523-0629</div>
                </div>
                <div className="location">
                  <div className="col-sm-4">新竹巨城</div>
                  <div className="col-sm-4">新竹市中央路229號6樓</div>
                  <div className="col-sm-4">03-515-2207</div>
                </div>
              </div>
              <div className="store feature boxed">
                <h3><i className="icon-Map-Marker2"></i>台中</h3>
                <div className="location">
                  <div className="col-sm-4">台中中友</div>
                  <div className="col-sm-4">台中市三民路三段161號B棟10樓</div>
                  <div className="col-sm-4">04-2225-2953</div>
                </div>
                <div className="location">
                  <div className="col-sm-4">台中新光</div>
                  <div className="col-sm-4">台中市臺灣大道三段301號8樓</div>
                  <div className="col-sm-4">04-2255-7551</div>
                </div>
                <div className="location">
                  <div className="col-sm-4">台中遠百</div>
                  <div className="col-sm-4">台中市臺灣大道三段251號9樓北棟</div>
                  <div className="col-sm-4">04-3703-3292</div>
                </div>
              </div> 
              <div className="store feature boxed">
                <h3><i className="icon-Map-Marker2"></i>台南</h3>
                <div className="location">
                  <div className="col-sm-4">台南新天地</div>
                  <div className="col-sm-4">台南市中西區西門路一段658號B1</div>
                  <div className="col-sm-4">06-303-0667</div>
                </div>
              </div>
              <div className="store feature boxed">
                <h3><i className="icon-Map-Marker2"></i>高雄</h3>
                <div className="location">
                  <div className="col-sm-4">高雄漢神巨蛋</div>
                  <div className="col-sm-4">高雄市左營區博愛二路777號B1</div>
                  <div className="col-sm-4">07-555-9131</div>
                </div>
                <div className="location">
                  <div className="col-sm-4">高雄大遠百</div>
                  <div className="col-sm-4">高雄市苓雅區三多四路21號10樓</div>
                  <div className="col-sm-4">07-970-0625</div>
                </div>
                <div className="location">
                  <div className="col-sm-4">高雄夢時代</div>
                  <div className="col-sm-4">高雄市前鎮區中華五路789號B2</div>
                  <div className="col-sm-4">07-811-2886</div>
                </div>
              </div>
            </div>
					</div>
				</div>
			</section>
    )
  }
}  

export default withRouter(Store);


// WEBPACK FOOTER //
// ./src/containers/Store/index.js